var _defs, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNodata(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Object",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 405.96 412.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: url(#_\u672A\u547D\u540D\u6F38\u5C64_75);\n      }\n\n      .st1 {\n        fill: url(#_\u672A\u547D\u540D\u6F38\u5C64_76);\n      }\n\n      .st2 {\n        fill: url(#_\u672A\u547D\u540D\u6F38\u5C64_77);\n      }\n\n      .st3 {\n        fill: url(#_\u672A\u547D\u540D\u6F38\u5C64_753);\n      }\n\n      .st4 {\n        fill: url(#_\u672A\u547D\u540D\u6F38\u5C64_754);\n      }\n\n      .st5 {\n        fill: url(#_\u672A\u547D\u540D\u6F38\u5C64_752);\n      }\n\n      .st6 {\n        fill: url(#_\u672A\u547D\u540D\u6F38\u5C64_757);\n      }\n\n      .st7 {\n        fill: url(#_\u672A\u547D\u540D\u6F38\u5C64_751);\n      }\n\n      .st8 {\n        fill: url(#_\u672A\u547D\u540D\u6F38\u5C64_758);\n      }\n\n      .st9 {\n        fill: url(#_\u672A\u547D\u540D\u6F38\u5C64_759);\n      }\n\n      .st10 {\n        fill: url(#_\u672A\u547D\u540D\u6F38\u5C64_756);\n      }\n\n      .st11 {\n        fill: url(#_\u672A\u547D\u540D\u6F38\u5C64_755);\n      }\n\n      .st12 {\n        fill: url(#_\u672A\u547D\u540D\u6F38\u5C64_771);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u672A\\u547D\\u540D\\u6F38\\u5C64_75",
    "data-name": "\\u672A\\u547D\\u540D\\u6F38\\u5C64 75",
    x1: 139.24,
    y1: 172.51,
    x2: 138.62,
    y2: 222.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eeeff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d2d6e0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u672A\\u547D\\u540D\\u6F38\\u5C64_751",
    "data-name": "\\u672A\\u547D\\u540D\\u6F38\\u5C64 75",
    x1: 208.16,
    y1: 216.71,
    x2: 276.36,
    y2: 222.08,
    xlinkHref: "#_\\u672A\\u547D\\u540D\\u6F38\\u5C64_75"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u672A\\u547D\\u540D\\u6F38\\u5C64_752",
    "data-name": "\\u672A\\u547D\\u540D\\u6F38\\u5C64 75",
    x1: 252.44,
    y1: 118.45,
    x2: 275.65,
    y2: 95.24,
    xlinkHref: "#_\\u672A\\u547D\\u540D\\u6F38\\u5C64_75"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u672A\\u547D\\u540D\\u6F38\\u5C64_753",
    "data-name": "\\u672A\\u547D\\u540D\\u6F38\\u5C64 75",
    x1: 193.01,
    y1: 170.14,
    x2: 202.61,
    y2: 185.07,
    xlinkHref: "#_\\u672A\\u547D\\u540D\\u6F38\\u5C64_75"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u672A\\u547D\\u540D\\u6F38\\u5C64_754",
    "data-name": "\\u672A\\u547D\\u540D\\u6F38\\u5C64 75",
    x1: 163.63,
    y1: 112.58,
    x2: 175.36,
    y2: 126.45,
    xlinkHref: "#_\\u672A\\u547D\\u540D\\u6F38\\u5C64_75"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u672A\\u547D\\u540D\\u6F38\\u5C64_77",
    "data-name": "\\u672A\\u547D\\u540D\\u6F38\\u5C64 77",
    x1: 48.83,
    y1: 122.83,
    x2: 51.1,
    y2: 128.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#eeeff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d2d6e0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u672A\\u547D\\u540D\\u6F38\\u5C64_771",
    "data-name": "\\u672A\\u547D\\u540D\\u6F38\\u5C64 77",
    x1: 257.87,
    y1: 33.04,
    x2: 260.13,
    y2: 38.51,
    xlinkHref: "#_\\u672A\\u547D\\u540D\\u6F38\\u5C64_77"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u672A\\u547D\\u540D\\u6F38\\u5C64_755",
    "data-name": "\\u672A\\u547D\\u540D\\u6F38\\u5C64 75",
    x1: 116.22,
    y1: 67.03,
    x2: 132.22,
    y2: 51.83,
    xlinkHref: "#_\\u672A\\u547D\\u540D\\u6F38\\u5C64_75"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u672A\\u547D\\u540D\\u6F38\\u5C64_756",
    "data-name": "\\u672A\\u547D\\u540D\\u6F38\\u5C64 75",
    x1: 316.59,
    y1: 145.71,
    x2: 326.24,
    y2: 136.55,
    xlinkHref: "#_\\u672A\\u547D\\u540D\\u6F38\\u5C64_75"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u672A\\u547D\\u540D\\u6F38\\u5C64_757",
    "data-name": "\\u672A\\u547D\\u540D\\u6F38\\u5C64 75",
    x1: 281.62,
    y1: 216.67,
    x2: 217.62,
    y2: 338.39,
    xlinkHref: "#_\\u672A\\u547D\\u540D\\u6F38\\u5C64_75"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u672A\\u547D\\u540D\\u6F38\\u5C64_76",
    "data-name": "\\u672A\\u547D\\u540D\\u6F38\\u5C64 76",
    x1: 271.65,
    y1: 175.5,
    x2: 297.64,
    y2: 243.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eeeff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#e8eaee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d2d6e0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u672A\\u547D\\u540D\\u6F38\\u5C64_758",
    "data-name": "\\u672A\\u547D\\u540D\\u6F38\\u5C64 75",
    x1: 177.92,
    y1: 238.89,
    x2: 101.75,
    y2: 296.81,
    xlinkHref: "#_\\u672A\\u547D\\u540D\\u6F38\\u5C64_75"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u672A\\u547D\\u540D\\u6F38\\u5C64_759",
    "data-name": "\\u672A\\u547D\\u540D\\u6F38\\u5C64 75",
    x1: 115.71,
    y1: 201.94,
    x2: 99.26,
    y2: 250.49,
    xlinkHref: "#_\\u672A\\u547D\\u540D\\u6F38\\u5C64_75"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M78.59,173.49l120.07-26.42v123.54s-120.07,26.42-120.07,26.42v-123.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M318.74,173.49l-120.13-26.42v120.81s120.13,26.42,120.13,26.42v-120.81Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M263.89,122.88c8.77,0,15.87-7.11,15.87-15.87s-7.11-15.87-15.87-15.87-15.87,7.11-15.87,15.87,7.11,15.87,15.87,15.87Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M199.24,189.49c5.33,0,9.65-4.32,9.65-9.65s-4.32-9.65-9.65-9.65-9.65,4.32-9.65,9.65,4.32,9.65,9.65,9.65Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M169.43,127.34c4.37,0,7.91-3.54,7.91-7.91s-3.54-7.91-7.91-7.91-7.91,3.54-7.91,7.91,3.54,7.91,7.91,7.91Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M50.09,130.64c2.63,0,4.77-2.14,4.77-4.77s-2.13-4.77-4.77-4.77-4.77,2.14-4.77,4.77,2.14,4.77,4.77,4.77Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M259.13,40.84c2.63,0,4.77-2.14,4.77-4.77s-2.13-4.77-4.77-4.77-4.77,2.14-4.77,4.77,2.14,4.77,4.77,4.77Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M139.59,53.72h-9.54v-9.48c0-1.88-1.52-3.4-3.4-3.4s-3.4,1.52-3.4,3.4v9.48h-9.48c-1.88,0-3.4,1.52-3.4,3.4s1.52,3.4,3.4,3.4h9.48v9.48c0,1.88,1.52,3.4,3.4,3.4s3.4-1.52,3.4-3.4v-9.48h9.54c1.88,0,3.4-1.52,3.4-3.4s-1.52-3.4-3.4-3.4Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M330.69,137.69h-5.76v-5.72c0-1.13-.92-2.05-2.05-2.05s-2.05.92-2.05,2.05v5.72h-5.72c-1.13,0-2.05.92-2.05,2.05s.92,2.05,2.05,2.05h5.72v5.72c0,1.13.92,2.05,2.05,2.05s2.05-.92,2.05-2.05v-5.72h5.76c1.13,0,2.05-.92,2.05-2.05s-.92-2.05-2.05-2.05Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M199.02,214.32l120.22-41.16v131.43l-120.22,59.52v-149.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M253.97,265.91l120.22-51.1-54.96-41.64-120.22,41.16,54.96,51.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M199.02,214.32l-120.42-41.16v131.43s120.42,59.52,120.42,59.52v-149.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M144.06,265.91l-120.22-51.1,54.96-41.64,120.22,41.16-54.96,51.58Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodata);
export default __webpack_public_path__ + "static/media/nodata.ca3b608c34e1117c42efcda87dfe91ed.svg";
export { ForwardRef as ReactComponent };